// types
import { Entity } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Grid, Paper, Typography } from '@mui/material';

// links
import { LinkEntity } from '../../links/LinkEntity/LinkEntity';

// ui
import { entityIconTypes, IconCircle } from '../../ui/IconCircle/IconCircle';

export interface CardEntitiesProps {
	entities: Entity[];
}

export const CardEntities = ({ entities = [] }: CardEntitiesProps) => {
	// hooks
	const { t } = useTranslation();

	const renderContent = () => {
		if (entities.length) {
			return (
				<Grid container spacing={2}>
					{entities.map((entity) => {
						return (
							<Grid item xs={12}>
								<Grid alignItems="center" container spacing={1}>
									<Grid item>
										<IconCircle size="sm" type={entityIconTypes[entity.type]} />
									</Grid>
									<Grid item flex={1}>
										<LinkEntity entity={entity} />
									</Grid>
								</Grid>
							</Grid>
						);
					})}
				</Grid>
			);
		}

		return t('na');
	};

	return (
		<Paper sx={{ height: '100%', padding: 2 }}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h3">{t('associatedEntities')}</Typography>
				</Grid>
				<Grid item xs={12}>
					{renderContent()}
				</Grid>
			</Grid>
		</Paper>
	);
};
